const React = require('react');
const PropTypes = require('prop-types');
import { connect } from 'react-redux';
// @ commons
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { countActiveFilters } = require('utilities/filtersHelper');
const { CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');
// @ actions
import { removeCheckFilter, removeFilterDate, removeFilterTag, removeSelectFilter, removeAmountFilter, removeFilter } from 'actions/filters';
const {
    requestAccountDebits
} = require('actions/accountDebits');
class FilterTags extends React.PureComponent {
    constructor(props) {
        super(props);
         this.state = {
            filterRemoved: false
         }
         this.handleClearFilter = this.handleClearFilter.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { filtersId, immFilters, onFilter, removeFilterTag } = nextProps;
        const filter = this.checkRemovedFromTag(immFilters);
        if (filter) {
            onFilter();
            removeFilterTag(filtersId, filter.get('filterId'));
        }
    }

    checkRemovedFromTag = (immFilters) => {
        return immFilters && immFilters.find((filter) => {
            return filter.get('removedFromTag');
        });
    }

    getAppliedFilters = (immFilters) => {
        return immFilters && immFilters.keySeq().reduce((acc, filterId) => {
            const filter = immFilters.get(filterId);
            return acc.concat(filter.get('filterTag') || filter.get('filterTagFrom') ? filter : []);
        }, []);
    }

    removeCheckFilter = (filter) => {
        const { filtersId, removeCheckFilter } = this.props;
        removeCheckFilter(filtersId, filter.get('filterId'));
        this.setState({filterRemoved: true});
    }

    removeFilterDate = (filter) => {
        const { filtersId, removeFilterDate } = this.props;
        removeFilterDate(filtersId, filter.get('filterId'));
        this.setState({filterRemoved: true});
    }

    removeSelectFilter = (filter) => {
        const { filtersId, removeSelectFilter } = this.props;
        removeSelectFilter(filtersId, filter.get('filterId'));
        this.setState({filterRemoved: true});
    }

    removeFilterAmount = (filter) => {
        const { filtersId, removeAmountFilter } = this.props;
        removeAmountFilter(filtersId, filter.get('filterId'));
        this.setState({filterRemoved: true});
    }

    renderCheckFilterTag = (filter) => {
        const filterId = filter.get('filterId');
        const filterTag = filter.get('filterTag');
        return(
            <LabelFilterRange
                key={filterId}
                from={filterTag}
                closeCallback={() => this.removeCheckFilter(filter)}
            />
        )
    }

    renderSelectFilterTag = (filter) => {
        const filterId = filter.get('filterId');
        const filterTag = filter.get('filterTag');
        return (
            <LabelFilterRange
                key={filterId}
                from={filterTag}
                closeCallback={() => this.removeSelectFilter(filter)}
            />
        );
    }

    renderDateFilterTag = (filter) => {
        const filterId = filter.get('filterId');
        const filterTagFrom = filter.get('filterTagFrom');
        const filterTagTo = filter.get('filterTagTo');
        return (
            <LabelFilterRange
                key={filterId}
                from={filterTagFrom}
                to={filterTagTo}
                closeCallback={() => this.removeFilterDate(filter)}
            />
        );
    }

    renderAmountFilterTag = (filter) => {
        const filterId = filter.get('filterId');
        const filterTagFrom = filter.get('filterTagFrom');
        const filterTagTo = filter.get('filterTagTo');
        return (
            <LabelFilterRange
                key={filterId}
                from={filterTagFrom}
                to={filterTagTo}
                closeCallback={() => this.removeFilterAmount(filter)}
            />
        );
    }

    renderFilterTag = (filter) => {
        const filterType = filter.get('filterType');
        if (filterType == 'checkFilter') {
            return this.renderCheckFilterTag(filter);
        } else if (filterType == 'selectorFilter' || filterType == 'radioFilter') {
            return this.renderSelectFilterTag(filter);
        } else if (filterType == 'dateFilter') {
            return this.renderDateFilterTag(filter);
        } else if (filterType == 'amountFilter') {
            return this.renderAmountFilterTag(filter);
        }
    }

    renderFilterTags = () => {
        const { immFilters } = this.props;
        if (immFilters && immFilters.size) {
            const activeFilters = this.getAppliedFilters(immFilters);
            if (activeFilters.length) {
                return activeFilters.map(filter => {
                    return this.renderFilterTag(filter);
                })
            } else {
                return null;
            }
        }
    }

    handleClearFilter = () => {
        this.props.removeFilter();
        this.props.clearFilters();
    }

    createButtonClearAllFilters() {
        const { immFilters } = this.props;
        const activeFilters = this.getAppliedFilters(immFilters);
        let response;
        if(immFilters) {
            if (activeFilters.length > 1) {
                response = <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={this.handleClearFilter} />;
            }
        }

        return response;
    }

    render() {
        const { filtersId} = this.props;
        let clearAllFiltersButton;
        if(filtersId === 'receipts'){
            clearAllFiltersButton = this.createButtonClearAllFilters()
        }
        return (
            <div className="genercic-filters__tags" >
                { this.renderFilterTags() }
                { clearAllFiltersButton }
            </div>
        );
    }
}

FilterTags.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    immFilters: PropTypes.object,
    filtersId: PropTypes.string,
    onFilter: PropTypes.func.isRequired,
    removeCheckFilter: PropTypes.func.isRequired,
    removeFilterDate: PropTypes.func.isRequired,
    removeFilterTag: PropTypes.func.isRequired,
    removeSelectFilter: PropTypes.func.isRequired,
    removeAmountFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func,
    requestAccountDebits: PropTypes.func
}

export default connect(
    (state, ownProps) => ({
        immFilters: state.filters.get(ownProps.filtersId),
    }),
    {
        removeCheckFilter,
        removeFilterDate,
        removeFilterTag,
        removeSelectFilter,
        removeAmountFilter,
        removeFilter,
        requestAccountDebits
    }
)(FilterTags);
